import { QueryClient } from '@tanstack/react-query';
import { getGuide, GetGuideRequestOption, Guide } from '~/monolith-api';
import { ApiClient } from '@dozuki/web-js/utils';
import { useRegisteredQuery } from '~/queries';

const KEY = 'guide';

export function getGuideKey(guideid: number | null) {
   return [KEY, guideid];
}

export function useGuide(guideid: number | null, options: GetGuideRequestOption = {}) {
   return useRegisteredQuery([KEY, guideid], async (): Promise<Guide | null> => {
      return await getGuide(guideid, options);
   });
}

export async function prefetchGuide(
   guideid: number,
   apiClient: ApiClient,
   queryClient: QueryClient
): Promise<void> {
   await queryClient.fetchQuery(getGuideKey(guideid), () => getGuide(guideid, { apiClient }));
}
